module.exports = __webpack_public_path__ + "static/media/Booking-01.2db84080.png";